export default __webpack_public_path__ + "static/media/fireplaces.9037367a.jpg";